import React from "react";
import "./SkillsInfo.css";

const WInfo = () => {
  return (
    <>

      <p className="skill__key">W</p>
      <h5 className="skill_name">SHIELD VAULT</h5>
      <p className="skill_infos">
        Pantheon dashes to a target, damaging and stunning them.
      </p>
    </>
  );
};

export default WInfo;
